<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="報告下載" name="download">
      <DownloadPage />
    </el-tab-pane>

    <el-tab-pane label="月報圖表" name="first">
      <MonthlyReportComponent @report-generated="handleReportGenerated" />
    </el-tab-pane>
    <el-tab-pane label="儀器曲線" name="second">
      <ReportComponent 
        :enableAutoRain1D="false"
        :visible-categories="['TM', 'ELP']" 
        :initialDateRange="alertDateRange"
        :y-axis-fixed-map-config="{
          TM: { 
            'mm/10M': { min: 0, max: 18, tickInterval: 3 }, 
            'mm': { min: -30, max: 30, tickInterval: 10 },
          },
        }"
      />
    </el-tab-pane>
    <el-tab-pane label="歷年TM儀器曲線" name="third">
      <ReportComponent 
        :disableLongDateRange="false"
        :visible-categories="['TM']" 
        :initialDateRange="historyTMDateRange"
        :y-axis-fixed-map-config="{
          TM: { 
            'mm/日': { min: 0, max: 200, tickInterval: 25 }, 
            'mm': { min: -40, max: 40, tickInterval: 10 },
          },
        }"
      />
    </el-tab-pane>
    <el-tab-pane 
      v-if="hasAlertData"
      label="本月水位變化量達(≥ ±0.3m)ELP儀器曲線" 
      name="fourth"
    >
      <ReportComponent 
        :visible-categories="['ELP']"
        :initialDateRange="alertDateRange"
        :filterInstrumentNames="alertInstrumentNames"
      />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import MonthlyReportComponent from '../components/report/autoMonthlyReportComponent.vue';
import ReportComponent from '../components/report/autoReportComponent.vue';
import DownloadPage from '../components/report/DownloadPage.vue';

export default {
  components: {
    MonthlyReportComponent,
    ReportComponent,
    DownloadPage,
  },
  data() {
    return {
      activeName: 'download',
      alertDateRange: [],
      historyTMDateRange: [],
      alertInstrumentNames: [],
      hasAlertData: false,
    };
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    handleReportGenerated(payload) {
      this.alertDateRange = payload.dateRange;
      // historyTMDateRange 的開始日期為 dateRange 的結束日期往前推一年的1月1號00:00
      const startDate = new Date(this.alertDateRange[1]);
      startDate.setFullYear(startDate.getFullYear() - 1);
      startDate.setMonth(0);
      startDate.setDate(1);
      startDate.setHours(0, 0, 0, 0);

      this.historyTMDateRange = [startDate, this.alertDateRange[1]];
      console.log('historyTMDateRange', this.historyTMDateRange);
      this.alertInstrumentNames = payload.names;
      
      // 只有當篩選出有異常的儀器時，才顯示第四個 Tab
      if (this.alertInstrumentNames && this.alertInstrumentNames.length > 0) {
        this.hasAlertData = true;
      } else {
        this.hasAlertData = false;
        // 如果當前正在第四頁卻變成了隱藏，切換回第一頁
        if (this.activeName === 'fourth') {
          this.activeName = 'download';
        }
      }
    },
  },
};
</script>